function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { useKey, useValue, DataTestId } from '@jvs-group/jvs-mairistem-tools';
import { Container, Icon, List, Modal } from "../..";
import useForceUpdate from "../../hooks/useForceUpdate";
import CollectionListConfirm from "./CollectionListConfirm";
import CollectionListForm from "./CollectionListForm";
import CollectionListItem from "./CollectionListItem";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function getColumnsNumber(columns) {
  if (typeof columns === 'number') {
    return columns;
  }
  switch (columns) {
    case 'one':
      return 1;
    case 'two':
      return 2;
    case 'three':
      return 3;
    case 'four':
      return 4;
    case 'five':
      return 5;
    case 'six':
      return 6;
    case 'seven':
      return 7;
    case 'eight':
      return 8;
    case 'nine':
      return 9;
    case 'ten':
      return 10;
    default:
      return 1;
  }
}

/**
 * A collection groups related content.
 * @see CollectionListItem
 */
var CollectionList = function CollectionList(props) {
  var defaultOpenedForm = props.defaultOpenedForm,
    items = props.items,
    horizontal = props.horizontal,
    columns = props.columns,
    wrappable = props.wrappable;
  var forceUpdate = useForceUpdate();
  var columnsNumber = useMemo(function () {
    return getColumnsNumber(columns);
  }, [columns]);
  var _useState = useState(false),
    newed = _useState[0],
    setNewed = _useState[1];
  var _useState2 = useState(false),
    openForm = _useState2[0],
    setOpenForm = _useState2[1];
  var _useState3 = useState(null),
    item = _useState3[0],
    setItem = _useState3[1];
  var _useState4 = useState(false),
    openConfirm = _useState4[0],
    setOpenConfirm = _useState4[1];
  var _useState5 = useState(false),
    saving = _useState5[0],
    setSaving = _useState5[1];
  var _useState6 = useState(null),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var widthView = useRef(null);
  useEffect(function () {
    var openFormLocal = false;
    var itemLocal = null;
    var newedLocal = false;
    if (defaultOpenedForm || defaultOpenedForm === 0) {
      if (defaultOpenedForm === true) {
        openFormLocal = true;
        newedLocal = true;
      } else if (items && defaultOpenedForm >= 0 && defaultOpenedForm < items.length) {
        openFormLocal = true;
        itemLocal = items[defaultOpenedForm];
      }
    }
    setOpenForm(openFormLocal);
    setNewed(newedLocal);
    setItem(itemLocal);
  }, []);

  /**
   * Initialise le ResizeObserver.
   */
  useEffect(function () {
    var context = props.context;
    if (!_.isNil(context) && _.isNil(widthView.current)) {
      var resizeObserver = new ResizeObserver(function (entries) {
        _.map(entries, function (entry) {
          if (entry.contentRect) {
            widthView.current = entry.contentRect.width;
            forceUpdate();
          }
        });
      });
      if (!_.isNil(context)) {
        resizeObserver.observe(context);
      }
    }
  });

  /**
   * Handle item overrides props.
   */
  var handleItemOverrides = function handleItemOverrides(control) {
    var itemControl = props.itemControl,
      itemForm = props.itemForm,
      formExtra = props.formExtra,
      itemMenu = props.itemMenu,
      itemMenuFirst = props.itemMenuFirst,
      itemSize = props.itemSize,
      itemIcon = props.itemIcon,
      onItemUpdate = props.onItemUpdate,
      onItemDelete = props.onItemDelete,
      onItemSelect = props.onItemSelect;
    var itemWidth = computeItemWidth();
    return Object.assign({
      control: itemControl,
      form: itemForm,
      extra: formExtra,
      menu: itemMenu,
      menuFirst: itemMenuFirst,
      size: itemSize,
      onItemSelect: onItemSelect,
      icon: itemIcon
    }, itemWidth, onItemUpdate && {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onUpdate: function onUpdate(e, item) {
        _.invoke(control, 'onUpdate', e, item);
        setNewed(false);
        setOpenForm(true);
        setItem(item);
      }
    }, onItemDelete && {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onDelete: function onDelete(e, item) {
        _.invoke(control, 'onDelete', e, item);
        setOpenConfirm(true);
        setItem(item);
      }
    });
  };

  /**
   * Compute item width.
   */
  var computeItemWidth = function computeItemWidth() {
    var context = props.context;
    if (horizontal && columnsNumber > 0 && !_.isNil(context) && !wrappable || wrappable && !horizontal) {
      var contextRef = window.getComputedStyle(context);
      var widthRef = _.toNumber(_.replace(contextRef.width, 'px', ''));
      var borderLeft = _.toNumber(_.replace(contextRef.borderLeftWidth, 'px', ''));
      var borderRight = _.toNumber(_.replace(contextRef.borderRightWidth, 'px', ''));
      var paddingLeft = _.toNumber(_.replace(contextRef.paddingLeft, 'px', ''));
      var paddingRight = _.toNumber(_.replace(contextRef.paddingRight, 'px', ''));
      var widthContext = _.isNumber(widthRef) && widthRef > 0 && (widthRef - borderLeft - borderRight - paddingLeft - paddingRight) * 0.95 / columnsNumber;
      return {
        style: {
          width: widthContext
        }
      };
    }
    return {};
  };

  /**
   * is the create button displayable
   */
  var isCreateButtonDisplayable = function isCreateButtonDisplayable() {
    var addButton = props.addButton,
      onAddButtonClick = props.onAddButtonClick,
      onItemCreate = props.onItemCreate,
      limit = props.limit;
    var nLimit = Number.parseInt(String(limit || 0), 10);
    var hasReachedItsLimit = !!(nLimit && items && items.length >= nLimit);
    var hasHandleForCreation = !!(onAddButtonClick || onItemCreate);
    var hasCustomButton = !!addButton;
    return (hasCustomButton || hasHandleForCreation) && !hasReachedItsLimit;
  };
  var handleCreate = function handleCreate(e, data) {
    var onAddButtonClick = props.onAddButtonClick,
      onItemCreate = props.onItemCreate;
    if (onAddButtonClick) {
      return onAddButtonClick(e, data);
    }
    if (onItemCreate) {
      setNewed(true);
      setItem(null);
      setOpenForm(true);
    }
    return null;
  };

  /**
   * Handle confirm event
   */
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var handleConfirm = function handleConfirm(event, item) {
    _.invoke(props, 'onItemDelete', event, item);
    setItem(null);
    setOpenConfirm(false);
  };

  /**
   * Handle save event
   */
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var handleSave = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, item, confirmationsData) {
      var result, isOk;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSaving(true);
            _context.next = 3;
            return _.invoke(props, newed ? 'onItemCreate' : 'onItemUpdate', event, item, confirmationsData);
          case 3:
            result = _context.sent;
            // === true obligatoire sinon il renvoit result
            isOk = _.isNil(result) || result === true;
            setNewed(function (prev) {
              return prev ? !isOk : false;
            });
            setItem(null);
            setOpenForm(!isOk);
            setSaving(false);
            setErrors(!isOk ? result : null);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSave(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Handle cancel event.
   */
  var handleCancel = function handleCancel() {
    setItem(null);
    setOpenForm(false);
    setOpenConfirm(false);
    setSaving(false);
    setErrors(null);
  };
  var handleError = function handleError(add, remove) {
    var newErrors = null;
    if (_.isString(add)) {
      newErrors = add;
    } else if (Array.isArray(add) || Array.isArray(remove)) {
      var _errors$filter;
      newErrors = [].concat(add || [], (_errors$filter = errors == null ? void 0 : errors.filter(function (e) {
        return !(remove != null && remove.find(function (r) {
          return (r == null ? void 0 : r.id) === (e == null ? void 0 : e.id);
        }));
      })) != null ? _errors$filter : []);
    } else {
      newErrors = _.omit(Object.assign({}, errors || {}, add || {}), Object.keys(remove || {}));
    }
    setErrors(newErrors);
  };

  /**
   * Render the form.
   */
  var renderConfirm = function renderConfirm() {
    var itemControl = props.itemControl,
      color = props.color;
    return /*#__PURE__*/_jsx(CollectionListConfirm, {
      open: openConfirm,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      confirmButton: {
        content: 'Supprimer',
        icon: 'trash',
        negative: true
      },
      control: itemControl,
      item: item,
      header: /*#__PURE__*/_jsxs(Modal.Header, {
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "trash"
        }), "\xCAtes-vous s\xFBr de vouloir supprimer cet \xE9l\xE9ment ?"]
      }),
      color: color
    });
  };

  /**
   * Render the form
   */
  renderConfirm.handledProps = [];
  var renderForm = function renderForm() {
    var color = props.color,
      itemForm = props.itemForm,
      formActions = props.formActions,
      formConfirmOn = props.formConfirmOn,
      formConfirmProps = props.formConfirmProps,
      formExtra = props.formExtra,
      formTitle = props.formTitle,
      formError = props.formError,
      modal = props.modal,
      modalContentProps = props.modalContentProps,
      saveButtonProps = props.saveButtonProps;
    return itemForm && /*#__PURE__*/_jsx(CollectionListForm, {
      actions: formActions,
      extra: formExtra,
      color: color,
      control: itemForm,
      confirmOn: formConfirmOn,
      confirmProps: formConfirmProps,
      item: item,
      open: openForm,
      onSave: handleSave,
      onCancel: handleCancel,
      formError: formError,
      onError: handleError,
      errors: errors,
      formTitle: formTitle,
      modal: modal,
      modalContentProps: modalContentProps,
      saveButton: Object.assign({}, saving && Object.assign({
        loading: true
      }, saveButtonProps), saveButtonProps)
    });
  };
  renderForm.handledProps = [];
  var renderPlus = function renderPlus(start) {
    if (start === void 0) {
      start = false;
    }
    var itemSize = props.itemSize,
      addButton = props.addButton;
    var itemWidth = computeItemWidth();
    var displayFlex = horizontal && !wrappable ? {
      display: 'flex'
    } : {};
    return isCreateButtonDisplayable() && /*#__PURE__*/_jsx(DataTestId.Accessor, {
      dataTestId: "collection-bouton-creer",
      children: function children(dataTestId) {
        return /*#__PURE__*/_jsx(CollectionListItem, {
          onClick: handleCreate,
          size: itemSize,
          style: start ? Object.assign({
            width: '100px'
          }, displayFlex) : Object.assign({}, itemWidth.style, displayFlex),
          children: /*#__PURE__*/_jsx(Container, {
            "data-testid": dataTestId,
            textAlign: "center",
            fluid: true,
            style: {
              flexGrow: 1,
              flexDirection: 'column',
              alignSelf: 'center'
            },
            children: addButton || /*#__PURE__*/_jsx(Icon, {
              name: "add",
              size: start ? 'large' : null,
              circular: true
            })
          })
        });
      }
    });
  };
  renderPlus.handledProps = [];
  var render = function render() {
    var children = props.children,
      className = props.className,
      content = props.content,
      doubling = props.doubling,
      addButtonPosition = props.addButtonPosition,
      stackable = props.stackable,
      disabled = props.disabled;
    var classes = classNames(useKey(doubling, 'doubling'), useKey(stackable, 'stackable'), useKey(wrappable, 'wrappable'), useKey(disabled, 'disabled'), useValue(columns), 'collectionlist', className);
    var rest = getRest(CollectionList, props);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(List, Object.assign({}, rest, {
          className: classes,
          horizontal: horizontal,
          celled: true,
          inverted: true,
          selection: true,
          children: [(addButtonPosition === 'start' || addButtonPosition === 'both') && renderPlus(true), children, (addButtonPosition === 'end' || addButtonPosition === 'both') && renderPlus()]
        })), renderConfirm(), renderForm()]
      });
    }
    if (!(_.isNil(content) || _.isEmpty(content))) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(List, Object.assign({}, rest, {
          className: classes,
          horizontal: horizontal,
          celled: true,
          inverted: true,
          selection: true,
          children: [(addButtonPosition === 'start' || addButtonPosition === 'both') && renderPlus(true), content, (addButtonPosition === 'end' || addButtonPosition === 'both') && renderPlus()]
        })), renderConfirm(), renderForm()]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(List, Object.assign({}, rest, {
        className: classes,
        horizontal: horizontal,
        celled: true,
        inverted: true,
        selection: true,
        children: [(addButtonPosition === 'start' || addButtonPosition === 'both') && !_.isEmpty(items) && renderPlus(true),
        // eslint-disable-next-line @typescript-eslint/no-shadow
        _.map(items, function (item) {
          return /*#__PURE__*/React.createElement(CollectionListItem, // @ts-expect-error Typing issue
          Object.assign({
            // eslint-disable-next-line no-nested-ternary
            key: !_.isNil(item.key) ? item.key : !_.isNil(item.identifiant) ? item.identifiant : _.uniqueId(),
            item: item
          }, handleItemOverrides()));
        }), (addButtonPosition === 'end' || addButtonPosition === 'both' || _.isEmpty(items)) && renderPlus()]
      })), renderConfirm(), renderForm()]
    });
  };
  render.handledProps = [];
  return render();
};

/**
 * Shorthand for CollectionListConfirm
 */
CollectionList.handledProps = ["addButtonPosition"];
CollectionList.Confirm = CollectionListConfirm;
/**
 * Shorthand for CollectionListForm
 */
CollectionList.Form = CollectionListForm;
/**
 * Shorthand for CollectionListItem
 */
CollectionList.Item = CollectionListItem;

/** Default props */
CollectionList.defaultProps = {
  addButtonPosition: 'end'
};
export default CollectionList;